export default __webpack_public_path__ + "images/nophoto-searchtile.jpg";